module.exports = __webpack_public_path__ + "img/bg3.7d5afe23.png";